<template>
  <div
    v-show="this.isLoading"
    class="bg-neutral-800/90 fixed top-0 left-0 w-screen h-screen flex justify-center items-center z-[9999]"
  >
    <div
      class="spinner w-[50px] h-[50px] border-4 border-gray-400 border-t-blue-600 rounded-full"
    ></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Loading",
  computed: {
    ...mapState("app", ["isLoading"]),
  },
};
</script>

<style>
.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
